import { useMedia } from 'use-media'
import { css } from '@emotion/react'

import Developers from 'gatsby-theme-marketplace-base/src/components/Developers'
import mediaQueries from '../../layout/media-queries'

const overrideCss = css`
  ${mediaQueries.largeScreen(-200)} {
    height: 410px;
    min-height: 410px;
    padding: 48px 60px;
  }

  .bannerInfo {
    ${mediaQueries.xsmallScreen(200)} {
      width: 100%;
    }

    ${mediaQueries.smallScreen()} {
      width: 53%;
    }

    ${mediaQueries.largeScreen()} {
      width: 40%;
    }
  }

  .markerText {
    ${mediaQueries.largeScreen(-200)} {
      left: 60px;
    }
  }

  .bannerDescription {
    h4 {
      ${mediaQueries.mediumScreen()} {
        font-size: 40px;
        line-height: 40px;
      }
    }
  }
`

const DevelopersWrapper = (props) => {
  const showMobile = useMedia({
    minWidth: mediaQueries.BASE_X_SMALL_SIZE,
    maxWidth: mediaQueries.BASE_SMALL_SIZE - 1,
  })

  return <Developers showMobile={showMobile} css={overrideCss} {...props} />
}

export default DevelopersWrapper
